import React from "react";

/**
 * BulletHole — SVG shattered-glass decoration.
 * Variants: 1 (clean), 2 (web), 3 (spider). Size in px.
 * Use absolutely-positioned and pointer-events:none.
 */
export default function BulletHole({ variant = 1, size = 80, className = "", style = {} }) {
  const id = `bh-${variant}-${size}`;
  const stroke = "rgba(245, 242, 238, 0.32)";
  const strokeFaint = "rgba(245, 242, 238, 0.14)";
  const core = "rgba(8, 8, 10, 0.95)";
  const halo = "rgba(255, 60, 60, 0.28)";

  const cracks = {
    1: [
      [50, 50, 90, 18], [50, 50, 92, 60], [50, 50, 76, 92],
      [50, 50, 18, 82], [50, 50, 6, 38], [50, 50, 28, 8],
    ],
    2: [
      [50, 50, 95, 12], [50, 50, 98, 48], [50, 50, 88, 80],
      [50, 50, 60, 97], [50, 50, 22, 88], [50, 50, 4, 64],
      [50, 50, 8, 28], [50, 50, 40, 4],
    ],
    3: [
      [50, 50, 92, 30], [50, 50, 88, 70], [50, 50, 50, 96],
      [50, 50, 12, 70], [50, 50, 8, 30], [50, 50, 50, 4],
      [50, 50, 75, 12], [50, 50, 75, 88], [50, 50, 25, 88], [50, 50, 25, 12],
    ],
  }[variant];

  return (
    <svg
      viewBox="0 0 100 100"
      width={size}
      height={size}
      className={`pointer-events-none select-none ${className}`}
      style={style}
      aria-hidden="true"
    >
      <defs>
        <radialGradient id={`${id}-glow`} cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor={halo} />
          <stop offset="60%" stopColor="transparent" />
        </radialGradient>
      </defs>
      <circle cx="50" cy="50" r="40" fill={`url(#${id}-glow)`} opacity="0.5" />
      {/* outer fragments */}
      {cracks.map(([x1, y1, x2, y2], i) => (
        <line
          key={`a-${i}`}
          x1={x1} y1={y1} x2={x2} y2={y2}
          stroke={i % 2 === 0 ? stroke : strokeFaint}
          strokeWidth="0.6"
        />
      ))}
      {/* concentric rings */}
      <circle cx="50" cy="50" r="14" fill="none" stroke={strokeFaint} strokeWidth="0.4" />
      <circle cx="50" cy="50" r="22" fill="none" stroke={strokeFaint} strokeWidth="0.3" strokeDasharray="2 3" />
      {/* secondary fractures */}
      {cracks.slice(0, 4).map(([, , x2, y2], i) => {
        const mx = 50 + (x2 - 50) * 0.4;
        const my = 50 + (y2 - 50) * 0.4;
        const px = mx + ((y2 - 50) * 0.18);
        const py = my - ((x2 - 50) * 0.18);
        return (
          <line key={`b-${i}`} x1={mx} y1={my} x2={px} y2={py}
                stroke={strokeFaint} strokeWidth="0.3" />
        );
      })}
      {/* core */}
      <circle cx="50" cy="50" r="3.6" fill={core} />
      <circle cx="50" cy="50" r="5" fill="none" stroke={stroke} strokeWidth="0.6" />
      <circle cx="49" cy="48.5" r="1.2" fill="rgba(255,255,255,0.18)" />
    </svg>
  );
}
